define('lib/Podio.Store.Text',['require','lib/Podio.Store'],function (require) {
  
  var podioStore = require('lib/Podio.Store');
  var dataStore = podioStore.create("last_text", true);
  
  function set(type, id, text) {
    dataStore.store("type", type);
    dataStore.store("id", id);
    dataStore.store("text", text);
  }
  
  function get(type, id) {
    if (dataStore.get("type") === type && dataStore.get("id") === id) {
      return dataStore.get("text");
    }
  }
  
  return {
    get: get,
    set: set
  };
});
